import React from 'react';

const Logo = ({ src, alt = '', width, height }) => (
  <div className="ws-ui-editor-header__logo">
    <img src={src} width={width} height={height} alt={alt} />
  </div>
);

export default Logo;
